<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-12 pb-5 main-card" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 mt-5 middle-background">
            <div class="pt-5 pl-3 pr-3">
                <div class="mt-4 ml-lg-4 ml-md-0 d-flex justify-content-between col-lg-9">
                    <span class="proximanova-semibold black">Notifications <span v-if="totalNotificationCount > 0">- {{totalNotificationCount}}</span> </span>
                    <img src="../assets/horizontal_menu_icon.svg" v-popover:fooNA width="20px" height="20px" id="notificationmoremenu" class="img-fluid pointer mr-md-4" alt="moremenu">
                    <popover name="fooNA" class="notificationActionsAll">
                        <div class="p-3">
                            <div class="d-flex p-1 action">
                                <img src="../assets/MarkasRead.svg" class="img-fluid" alt="markasread">
                                <span class="p-2 proximanova" @click="markAllasRead">Mark all as Read</span>
                            </div>
                            <div class="d-flex p-1 action">
                                <img src="../assets/NotificationsSettings.svg" class="img-fluid" alt="settings">
                                <span class="p-2 proximanova" @click="openNotificationSettings">Notification Settings</span>
                            </div>
                            <div class="d-flex p-1 action">
                                <img src="../assets/Deleteall.svg" class="img-fluid" alt="delete">
                                <span class="p-2 proximanova" @click="openDeleteConfirmationmodal">Delete all</span>
                            </div>
                        </div>
                    </popover>
                </div>
            </div>
             <div class=" ">
                <nav class="navigation  mt-4 ml-2 mr-5 col-lg-10 d-none d-lg-block">
                    <ul class=" pr-4">
                        <li class="border">
                            <a
                            class="black80 fontsize16 proximanova-semibold pointer"
                            :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'all_notifications'}"
                            id="all_notifications"
                            @click="toggleActiveClass('all_notifications')"
                             >All Notifications</a>
                            <div class="border-bottom"></div>

                            <a
                                class="black80 fontsize16 proximanova-semibold pointer"
                                :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'jobs'}"
                                id="jobs"
                                @click="toggleActiveClass('jobs')"
                            >Jobs</a>
                            <div class="border-bottom"></div>

                            <a
                                class="black80 fontsize16 proximanova-semibold pointer"
                                :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'videos'}"
                                id="videos"
                                @click="toggleActiveClass('videos')"
                            >Videos</a>
                            <div class="border-bottom"></div>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="col-md-12 col-lg-6 middle-background">
          <div class="row no-gutters">
            <br />
          </div>
         <div class=" col-12 ml-sm-1 no-gutters d-block d-lg-none">
            <ul class="nav nav-tabs p-2 font12-boldcolor d-flex  border rounded">
              <li class="nav-item ml-3 ">
                <a
                  class="black80 fontsize16 proximanova-semibold pointer"
                  :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'all_notifications'}"
                  id="all_notifications"
                  @click="toggleActiveClass('all_notifications')"
                >All Notifications</a>
              </li>
              <p class="mr-2 ml-2">|</p>
              <li class="nav-item ml-2 ">
                <a
                  class="black80 fontsize16 proximanova-semibold pointer"
                  :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'jobs'}"
                  id="jobs"
                  @click="toggleActiveClass('jobs')"
                >Jobs</a>
              </li>
              <p class="mr-2 ml-2">|</p>
              <li class="nav-item ml-md-2">
                <a
                  class="black80 fontsize16 proximanova-semibold pointer"
                  :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'videos'}"
                  id="videos"
                  @click="toggleActiveClass('videos')"
                >Videos</a>
              </li>
            </ul>
         </div>
         <div class="row no-gutters mt-lg-5 mt-md-1 mt-sm-1">
            <div class="col-lg-12">
                <div class="row no-gutters">
                    <br />
                </div>
                <div class="col-12 pb-5 mb-4 mt-5" v-if="individualpageloader">
                  <img src="../assets/pageloader.svg" class="instanceloader" alt="loading">
                </div>
                <div class="" v-else>
                    <div class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                        <!-- <div class="col-12">
                            <div class="card checkbagsearch col-12">
                                <div class="input-group pt-1">
                                    <div class="input-group-prepend" style="height:42px; margin-left:-10px">
                                        <span class="input-group-text img-input-group mt-0" id="basic-text1">
                                            <img src="../assets/Search.svg" height="42px" class="imgborder " alt="search"/>
                                        </span>
                                    </div>
                                    <input
                                    class="form-control"
                                    type="text"
                                    placeholder="Search Notifications"
                                    aria-label="Search"
                                    />
                                    <p class="black80 proximanova-semibold fontsize14 pr-3 pl-4 my-auto">Search</p>
                                </div>
                                
                            </div>
                            
                        </div> -->
                    </div>
                    <div class="row no-gutters ml-3  mr-3 mb-3">
                        <!-- <div class="col-12">
                            <span class="black80 proximanova-semibold fontsize14 ml-4">Today</span>    
                        </div> -->
                    </div>
                    <div v-if="totalNotificationList.length < 1 && !notificationSettings" class="ml-3 mr-3 ml-md-4 mr-lg-1">
                      <no-records-found :message="noRecordsFoundMessage"></no-records-found>
                    </div>
                    <div v-for="(item, index) in totalNotificationList" :key="index">
                      <!-- <span v-if="item.count == 0">{{item.dateStr}}</span> -->
                      <div class="col-12 mb-3" v-if="item.checkcount == 0 && !notificationSettings">
                          <span class="black80 proximanova-semibold fontsize14 ml-3 mr-3 ">{{item.dateStr}}</span>    
                      </div>
                      <div v-if="jobNotifications && !notificationSettings">
                        <div v-if="item.readFlag == 'N'" class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                          <div class="col-12">
                              <div class="card checkbagnotread">
                                  <div class="d-flex pt-2 pb-2">
                                      <div class="col-1 pt-1 ">
                                        <div v-if="!item.companyLogoLink" id="profImage" class=" text-center white fontsize14 rounded-circle white" :class="item.companyName.charAt(0)">
                                          <span class="white fontsize14 defpaddingtop text-uppercase">{{item.companyName.charAt(0)}}</span>
                                        </div>
                                        <img v-else :src="item.companyLogoLink" @error="item.companyLogoLink = null" class="userimg loadingBgImg rounded-circle notyprofile" alt="companylogo"/>
                                      </div>
                                      <div class="pl-sm-5 pl-md-3 pl-lg-2 ml-2 ml-md-0 col-9">
                                          <div class=" d-flex flex-column justify-content-between">
                                              <span class="black proximanova-semibold fontsize14">{{item.jobTitle}}</span>
                                              <span class="black60 proximanova fontsize12">{{item.companyName}}, {{item.cityName}}</span>
                                          </div>
                                          <div>
                                              <p class="black80 proximanova fontsize12 mb-0 mt-2" v-if="item.messageBody">{{item.messageBody}}</p>
                                          </div>
                                      </div>
                                      <div class="col-2 pl-0 pl-md-2 text-md-center ">
                                          <span class="black30 proximanova fontsize12">{{ item.creationD | moment("hh:mm a") }}</span>
                                          <br>
                                          <popover v-bind:name="item.popoverName" class="notificationActions">
                                              <div class="p-3">
                                                  <div class="d-flex p-1 action" v-if="item.readFlag == 'N'" @click="markasRead(item.id, index)">
                                                      <img src="../assets/MarkasRead.svg" class="img-fluid" alt="read">
                                                      <span class="p-2 proximanova">Mark as Read</span>
                                                  </div>
                                                  <div class="d-flex p-1 action" @click="notInterested(item.viewProfileId)">
                                                      <img src="../assets/NotInterested.svg" class="img-fluid" alt="notinterested">
                                                      <span class="p-2 proximanova">Not Interested</span>
                                                  </div>
                                                  <div class="d-flex p-1 action">
                                                      <img src="../assets/Reportasfraud.svg" class="img-fluid" alt="fraud">
                                                      <span class="p-2 proximanova">Report as fraud</span>
                                                  </div>
                                              </div>
                                          </popover>
                                      </div>
                                  </div> 
                              </div>
                          </div>
                        </div>
                        <div v-if="item.readFlag == 'Y'"  class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                            <div class="col-12">
                                <div class="card checkbag">
                                    <div class="d-flex pt-2 pb-2">
                                        <div class="col-1 pt-1">
                                          <div v-if="!item.companyLogoLink" id="profImage" class=" text-center white fontsize14 rounded-circle white" :class="item.companyName.charAt(0)">
                                            <span class="white fontsize14 defpaddingtop text-uppercase">{{item.companyName.charAt(0)}}</span>
                                          </div>
                                          <img v-else :src="item.companyLogoLink" @error="item.companyLogoLink = null" alt="companylogo" class="userimg loadingBgImg rounded-circle notyprofile"/>
                                        </div>
                                        <div class="pl-sm-5 pl-md-3 pl-lg-2 ml-2 ml-md-0 col-9">
                                            <div class=" d-flex justify-content-between">
                                              <span class="black proximanova-semibold fontsize14">{{item.jobTitle}}</span>
                                              <span class="black60 proximanova fontsize12">{{item.companyName}}, {{item.cityName}}</span>
                                            </div>
                                            <div>
                                                <p class="black80 proximanova fontsize12 mt-2 mb-0" v-if="item.messageBody">{{item.messageBody}}</p>
                                            </div>
                                        </div>
                                        <div class="col-2 pl-0 pl-md-2 text-md-center ">
                                            <span class="black30 proximanova fontsize12"><span v-if="item.lastUpdateD">{{ item.lastUpdatedD | moment("hh:mm a") }}</span>
                                              <span v-else>{{ item.creationD | moment("hh:mm a") }}</span>
                                            </span>
                                            <br>
                                            <popover v-bind:name="item.popoverName" class="notificationActions">
                                                <div class="p-3">
                                                    <div class="d-flex p-1 action" v-if="item.readFlag == 'N'" @click="markasRead(item.id, index)">
                                                        <img src="../assets/MarkasRead.svg" class="img-fluid" alt="read">
                                                        <span class="p-2 proximanova">Mark as Read</span>
                                                    </div>
                                                    <div class="d-flex p-1 action" @click="notInterested(item.viewProfileId)">
                                                        <img src="../assets/NotInterested.svg" class="img-fluid" alt="notintested">
                                                        <span class="p-2 proximanova">Not Interested</span>
                                                    </div>
                                                    <div class="d-flex p-1 action">
                                                        <img src="../assets/Reportasfraud.svg" class="img-fluid" alt="fraud">
                                                        <span class="p-2 proximanova">Report as fraud</span>
                                                    </div>
                                                </div>
                                            </popover>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                      </div>
                      <!-- <div v-else> -->
                      <div v-if="userandVideoNotifications && !notificationSettings">
                      <div v-if="item.readFlag == 'N'" @click="markasRead(item.id, index)" class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                          <div class="col-12">
                              <div class="card checkbagnotread">
                                  <div class="d-flex pt-2 pb-2">
                                      <div class="col-1 pt-1 ">
                                        <!-- <img v-if="!item.profilePictureLink" src="../assets/Profile_placehlder.svg" class="userimg rounded-circle notyprofile"/> -->
                                        <div v-if="!item.profilePictureLink" id="profImage" class=" text-center white fontsize14 rounded-circle white" :class="item.userName.charAt(0)">
                                          <span class="white fontsize14 defpaddingtop text-uppercase">{{item.userName.charAt(0)}}</span>
                                        </div>
                                        <img v-else :src="item.profilePictureLink" @error="item.profilePictureLink = null" alt="profilepic" class="userimg loadingBgImg rounded-circle notyprofile"/>
                                      </div>
                                      <div class="pl-sm-5 pl-md-3 pl-lg-2 ml-2 ml-md-0 col-9">
                                          <div class=" d-flex justify-content-between">
                                              <span class="black proximanova-semibold fontsize14">{{item.userName}} <span v-if="(item.count > 1) && (item.subject != 'VIEWPROFILE')"> & {{item.count - 1}} other's</span></span>
                                          </div>
                                          <div>
                                              <p class="black80 proximanova fontsize12 d-none d-lg-block mb-0" v-if="item.message">{{item.message.substr(0, 150)}}...</p>
                                              <p class="black80 proximanova fontsize12 d-block d-lg-none mb-0" v-if="item.message">{{item.message.substr(0, 80)}}...</p>
                                          </div>
                                      </div>
                                      <div class="col-2 pl-0 pl-md-2 text-md-center ">
                                          <span class="black30 proximanova fontsize12">{{ item.lastUpdatedD | moment("hh:mm a") }}</span>
                                          <!-- <span class="font12-opacity30">{{item.lastUpdatedD | moment("from", "now", true)}} ago</span> -->
                                          <br>
                                          <!-- <img src="../assets/horizontal_menu_icon.svg" v-popover = "{name: item.popoverName}" width="20px" class="img-fluid ml-lg-5 ml-md-5 ml-sm-5 notyicon" alt=""> -->
                                          <popover v-bind:name="item.popoverName" class="notificationActions">
                                              <div class="p-3">
                                                  <div class="d-flex p-1 action" v-if="item.readFlag == 'N'" @click="markasRead(item.id, index)">
                                                      <img src="../assets/MarkasRead.svg" alt="read" class="img-fluid">
                                                      <span class="p-2 proximanova">Mark as Read</span>
                                                  </div>
                                                  <div class="d-flex p-1 action" @click="notInterested(item.viewProfileId)">
                                                      <img src="../assets/NotInterested.svg" alt="notinterested" class="img-fluid">
                                                      <span class="p-2 proximanova">Not Interested</span>
                                                  </div>
                                                  <div class="d-flex p-1 action">
                                                      <img src="../assets/Reportasfraud.svg" alt="fraud" class="img-fluid">
                                                      <span class="p-2 proximanova">Report as fraud</span>
                                                  </div>
                                              </div>
                                          </popover>
                                      </div>
                                  </div> 
                              </div>
                          </div>
                      </div>
                      
                      <div v-if="item.readFlag == 'Y'"  class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                          <div class="col-12">
                              <div class="card checkbag">
                                  <div class="d-flex pt-2 pb-2">
                                      <div class="col-1 pt-1">
                                        <!-- <img v-if="!item.profilePictureLink" src="../assets/Profile_placehlder.svg" class="userimg rounded-circle notyprofile"/> -->
                                        <div v-if="!item.profilePictureLink" id="profImage" class=" text-center white fontsize14 rounded-circle white" :class="item.userName.charAt(0)">
                                          <span class="white fontsize14 defpaddingtop text-uppercase">{{item.userName.charAt(0)}}</span>
                                        </div>
                                        <img v-else :src="item.profilePictureLink" @error="item.profilePictureLink = null" alt="profilepic" class="userimg loadingBgImg rounded-circle notyprofile"/>
                                      </div>
                                      <div class="pl-sm-5 pl-md-3 pl-lg-2 ml-2 ml-md-0 col-9">
                                          <div class=" d-flex justify-content-between">
                                              <span class="black proximanova-semibold fontsize14">{{item.userName}} <span v-if="(item.count > 1) && (item.subject != 'VIEWPROFILE')"> & {{item.count -1 }} other's</span></span>
                                          </div>
                                          <div>
                                              <p class="black80 proximanova fontsize12 d-none d-lg-block mb-0" v-if="item.message">{{item.message.substr(0, 150)}}...</p>
                                              <p class="black80 proximanova fontsize12 d-block d-lg-none mb-0" v-if="item.message">{{item.message.substr(0, 80)}}...</p>
                                          </div>
                                      </div>
                                      <div class="col-2 pl-0 pl-md-2 text-md-center ">
                                          <span class="black30 proximanova fontsize12"><span v-if="item.lastUpdateD">{{ item.lastUpdatedD | moment("hh:mm a") }}</span>
                                            <span v-else>{{ item.lastUpdatedD | moment("hh:mm a") }}</span>
                                          </span>
                                          <!-- <span class="font12-opacity30">{{item.lastUpdatedD | moment("from", "now", true)}} ago</span> -->
                                          <br>
                                          <!-- <img src="../assets/horizontal_menu_icon.svg" v-popover = "{name: item.popoverName}" width="20px" class="img-fluid ml-lg-5 ml-md-5 ml-sm-5 notyicon" alt=""> -->
                                          <popover v-bind:name="item.popoverName" class="notificationActions">
                                              <div class="p-3">
                                                  <div class="d-flex p-1 action" v-if="item.readFlag == 'N'" @click="markasRead(item.id, index)">
                                                      <img src="../assets/MarkasRead.svg" alt="read" class="img-fluid">
                                                      <span class="p-2 proximanova">Mark as Read</span>
                                                  </div>
                                                  <div class="d-flex p-1 action" @click="notInterested(item.viewProfileId)">
                                                      <img src="../assets/NotInterested.svg" alt="notinterested" class="img-fluid">
                                                      <span class="p-2 proximanova">Not Interested</span>
                                                  </div>
                                                  <div class="d-flex p-1 action">
                                                      <img src="../assets/Reportasfraud.svg" alt="fraud" class="img-fluid">
                                                      <span class="p-2 proximanova">Report as fraud</span>
                                                  </div>
                                              </div>
                                          </popover>
                                      </div>
                                  </div> 
                              </div>
                          </div>
                      </div>
                      </div>
                    </div>
                    <div v-if="notificationSettings">
                      <div class="proximanova-semibold fontsize18 black60  ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">Notification Settings</div>
                      <div class="row no-gutters card p-4 ml-3 mr-3 ml-md-4 mr-lg-1 pb-5">
                        <div class="d-flex flex-column">
                          <span class="proximanova-bold fontsize18 black60 mb-3">Do Not Disturb</span>
                          <div class="line"></div>
                          <!-- all notifications -->
                          <div class="row mt-3 no-gutters">
                            <div class="d-flex flex-column col fontsize14 proximanova pointer">
                              <span class="proximanova-semibold fontsize16 black">All Notifications</span>
                              <span class="proximanova fontsize12 black60">When Do Not Disturb is turned on, we won’t send you any notifications</span>
                            </div>
                            <div class="custom-control custom-switch" >
                              <input
                                type="checkbox"
                                v-model="allnotificationschecked"
                                class="custom-control-input pointer"
                                id="allnotificationswitch"
                                true-value = "Y"
                                false-value = "N"
                                @change="updateNotificationSettings('all')"
                                :disabled="disableOptions"
                                name="example"
                              />
                              <label class="custom-control-label" for="allnotificationswitch"></label>
                            </div>
                          </div>
                          <!-- video notifications -->
                          <div class="row mt-3 no-gutters">
                            <div class="d-flex flex-column col fontsize14 proximanova pointer" >
                              <span class="proximanova-semibold fontsize16 black">Video Notifications</span>
                              <span class="proximanova fontsize12 black60">Notification reated to Post, Views, Comments, Share, Like, Tagged</span>
                            </div>
                            <div class="custom-control custom-switch" >
                              <input
                                type="checkbox"
                                v-model="videonotificationschecked"
                                class="custom-control-input pointer"
                                id="videonotificationswitch"
                                true-value = "Y"
                                false-value = "N"
                                @change="updateNotificationSettings('video')"
                                :disabled="disableOptions"
                                name="example"
                              />
                              <label class="custom-control-label" for="videonotificationswitch"></label>
                            </div>
                          </div>
                          <!-- job notifications -->
                          <div class="row mt-3 no-gutters">
                            <div class="d-flex flex-column col fontsize14 proximanova pointer" >
                              <span class="proximanova-semibold fontsize16 black">Job Notifications</span>
                              <span class="proximanova fontsize12 black60">Newly posted, Recommended, Intrested,  job Change, Application Status</span>
                            </div>
                            <div class="custom-control custom-switch">
                              <input
                                type="checkbox"
                                v-model="jobnotificationschecked"
                                class="custom-control-input pointer"
                                id="jobnotificationswitch"
                                true-value = "Y"
                                false-value = "N"
                                @change="updateNotificationSettings('job')"
                                :disabled="disableOptions"
                                name="example"
                              />
                              <label class="custom-control-label" for="jobnotificationswitch"></label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="col-12 pb-5 mb-5" v-if="instanceLoader">
                  <img src="../assets/pageloader.svg" class="instanceloader" alt="loading">
                </div>
                <!-- <div class="m-3 mb-5 pr-5 col-12 text-right" v-if="instanceNotificationList.length > 8">
                  <button class="loadmore pl-3 pr-3 pt-1 pb-1 mb-5" @click="loadMoreNotifications">Load More ...</button>
                </div> -->
            </div>
          </div>
        </div>
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters">
            <br />
          </div>
          <!-- penging activities component -->
          <pendingActivities />
        </div>
      </div>
    </div>
    <!-- <Footer class="footer d-block d-sm-block d-md-block d-lg-none" /> -->
    <delete-confirmation-modal  :modalTitle="modalTitle" v-if="deleteallconfirmationmodalopen" @closeConfirmModal = "DeleteAllConfirmationModal"></delete-confirmation-modal>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
  </div>
</template>
<script>
import pendingActivities from '../components/PendingActivities.vue'
import sidemenu from "@/components/SideMenu.vue";
import topmenu from "@/components/TopHeader.vue";
import httpuserprofile from "@/js/http-userprofile.js";
import httpjob from "@/js/http-postjob.js"
import Vue from "vue";
import Popover from "vue-js-popover";
import Footer from '../components/Footer'
import DeleteConfirmationModal from '../components/ConfirmationModal.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import NoRecordsFound from '../components/NoRecordsFound.vue'
import moment from 'moment'
import sessionUtils from '@/js/session-util.js'
import { time } from 'highcharts';

Vue.use(Popover);

export default {
  data() {
    return {
      showpending: true,
      jobchange : false,
      pageloader : true,
      individualpageloader : false,
      instanceLoader : false,
      instancegatData : false,
      activeClass: "all_notifications",
      modalTitle : "Are you sure you want to delete all notifications ?",
      profileId : sessionUtils.getUserProfileId(),
      startNumber : 0,
      limit : 10,
      jobNotifications : false,
      userandVideoNotifications : true,
      notificationSettings : false,
      totalNotificationList : [],
      instanceNotificationList : [],
      totalNotificationCount : 0,
      deleteallconfirmationmodalopen : false,
      displayAPIerrorModal : false,
      noRecordsFoundMessage : 'No Notifications found',
      // notification settings
      allnotificationschecked : "N",
      jobnotificationschecked : "N",
      videonotificationschecked : "N",
      disableOptions : false
    };
  },
  computed :{
      printDate : function(item){
        var date = new Date();
        // console.log(date)
        // console.log(item)
        //  return this.firstname +" "+ this.lastname;
      }
   },
  components: {
    sidemenu,
    topmenu,
    Footer,
    pendingActivities,
    DeleteConfirmationModal,
    NoRecordsFound,
    APIerrorModal
  },
  
   mounted() {
     //set page scroll
    window.scrollTo(0, 0)
    window.addEventListener('scroll', this.handleScroll);
    this.fetchNotificationsList()
    this.getNotificationSettingsData()
  },
  methods: {
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    toggleActiveClass(elementId) {
      this.activeClass = elementId;
      this.notificationSettings = false;
      if(this.activeClass == 'all_notifications') {
        this.clearData();
        this.jobNotifications = false;
        this.userandVideoNotifications = true;
        this.fetchNotificationsList();
      }else if(this.activeClass == 'videos'){
        this.clearData();
        this.jobNotifications = false;
        this.userandVideoNotifications = true;
        this.fetchVideoNotifications()
      }else if(this.activeClass == 'jobs') {
        this.clearData();
        this.jobNotifications = true;
        this.userandVideoNotifications = false;
        this.fetchJobNotifications();
      }
    },
    clearData(){
      this.startNumber = 0;
      this.individualpageloader = true;
      this.totalNotificationList = [];
      this.instanceNotificationList = [];
    },
    pending() {
      this.showpending = false;
    },
    // this will invoke after click on not interested option on more actions menu of individual notifications
    // to avoid getting the notifications from same id again
    notInterested : function(id) {
      // console.log("block profile Id : ", id)
      httpuserprofile.post('userprofile/blockUserNotification?profileId='+this.profileId+'&blockedUserProfileId='+id)
      .then((response) => {
        // console.log(response)
        this.startNumber = 0;
        this.totalNotificationCount = 0;
        this.instanceNotificationList = [];
        this.totalNotificationList = [];
        this.fetchNotificationsList()
      }).catch((error) => {
        console.log(error)
      })
    },
    // this will invoke after click on any single notification which is not read
    // mark the notification as read
    markasRead : function(id, index) {
      // console.log("clicked", id)
      // console.log("index : ", index)
      var that = this;
      httpuserprofile.put('userprofile/updateNotification?notificationId='+id)
      .then((response) => {
        console.log(response)
        //update notifications list after one value is updated
        // console.log(that.totalNotificationList[index])
        that.totalNotificationList[index].readFlag = 'Y'
        that.totalNotificationCount = that.totalNotificationCount-1;
        that.$store.state.notificationCount = that.totalNotificationCount;
        // this.startNumber = 0;
        // this.totalNotificationCount = 0;
        // this.totalNotificationList = []
        // this.instanceNotificationList = []
        // this.fetchNotificationsList()
      }).catch((error) => {
        console.log(error)
        this.displayAPIerrorModal = true;
      })
    },
    loadMoreNotifications : function() {
      this.startNumber = this.startNumber + 10;
      this.fetchNotificationsList()
    },
    loadMoreVideoNotifications() {
      this.startNumber = this.startNumber + 10;
      this.fetchVideoNotifications()
    },
    // this will invoke after click on mark all as read on moreactions menu
    // mark all notifications as read
    markAllasRead : function() {
      // console.log("mark all as Read")
      var menu = document.getElementById('notificationmoremenu')
      menu.click()
      var that = this;
      if(this.totalNotificationList && this.totalNotificationList.length > 0){
      httpuserprofile.put("/userprofile/updateAllNotificationAsRead?profileId="+this.profileId+'&readFlag='+'Y'
      ).then((response) => {
        console.log(response)
        this.totalNotificationList.forEach(function(d){
          d.readFlag = 'Y'
        })
        that.totalNotificationCount = 0;
        that.$store.state.notificationCount = that.totalNotificationCount;
        // this.startNumber = 0;
        // this.totalNotificationCount = 0;
        // this.totalNotificationList = [];
        // this.instanceNotificationList = [];
        // this.fetchNotificationsList();
      }).catch((error) => {
        console.log(error)
        this.displayAPIerrorModal = true;
      })
      }
    },
    //notification settings screen
    openNotificationSettings : function() {
      var menu = document.getElementById('notificationmoremenu')
      menu.click()
      this.notificationSettings = true;
      this.jobNotifications = false;
      this.userandVideoNotifications = false;
      // console.log("check")
    },
    // this will invoke after click on delete all button on moreactions menu
    // to delete all the notifications
    openDeleteConfirmationmodal(){
      var menu = document.getElementById('notificationmoremenu')
      menu.click()
      if(this.totalNotificationList && this.totalNotificationList.length > 0){
      this.deleteallconfirmationmodalopen = true;
      console.log(this.deleteallconfirmationmodalopen)
      }
    },
    DeleteAllConfirmationModal(deleteAllconfirm){
      if(deleteAllconfirm == 'SUCCESS'){
        // console.log("api call to delete all notifications")
        this.deleteallconfirmationmodalopen = false;
        this.deleteAll()
      }else{
        console.log("cancel delete all notifications")
        this.deleteallconfirmationmodalopen = false;
      }
    },
    deleteAll : function() {
      // console.log("delete All");
      httpuserprofile.delete("/userprofile/deleteAllNotification",{
        params: { profileId : this.profileId}
      }).then((response) => {
        console.log(response)
        this.startNumber = 0;
        this.totalNotificationCount = 0 ;
        this.totalNotificationList = [];
        this.instanceNotificationList = [];
      }).catch((error) => {
        console.log(error)
        this.displayAPIerrorModal = true;
      })
    },
    //get block notification data
    getNotificationSettingsData : function() {
      httpuserprofile.get("/userprofile/getUserDoNotDisturbNotification?profileId="+this.profileId)
      .then((response) => {
        console.log("notification settings data", response)
        if(response.data){
          this.allnotificationschecked = response.data.allNotifiacations;
          this.videonotificationschecked = response.data.videoNotifiacations;
          this.jobnotificationschecked = response.data.jobNotifiacations;
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    updateNotificationSettings : function(type) {
      console.log(type, this.allnotificationschecked, this.videonotificationschecked, this.jobnotificationschecked)
      this.disableOptions = true;
      if(this.profileId){
        // if(type == 'all'){
        //   if(this.allnotificationschecked == 'Y'){
        //     console.log("if y")
        //     this.allnotificationschecked = 'N'
        //   }else{
        //     console.log("if n")
        //     this.allnotificationschecked = 'Y'
        //   }
        // }else if(type == 'video') {
        //   if(this.videonotificationschecked == 'Y'){
        //     console.log("if y")
        //     this.videonotificationschecked = 'N'
        //   }else{
        //     console.log("if n")
        //     this.videonotificationschecked = 'Y'
        //   }
        // }else if(type == 'job'){
        //   if(this.jobnotificationschecked == 'Y'){
        //     console.log("if y")
        //     this.jobnotificationschecked = 'N'
        //   }else{
        //     console.log("if n")
        //     this.jobnotificationschecked = 'Y'
        //   }
        // }
        // console.log(type, this.allnotificationschecked, this.videonotificationschecked, this.jobnotificationschecked)
        this.updateBlockNotificationSettings()
      }
    },
    updateBlockNotificationSettings : function() {
      httpuserprofile.post("/userprofile/doNotDisturbUserNotifiaction?profileId="+this.profileId+"&allNotifications="+this.allnotificationschecked+"&jobNotifications="+this.jobnotificationschecked+"&videoNotifications="+this.videonotificationschecked)
      .then((response) => {
        console.log("after updating notification settings data", response.data)
        this.disableOptions = false;
        if(response.data){
          this.allnotificationschecked = response.data.allNotifiacations;
          this.videonotificationschecked = response.data.videoNotifiacations;
          this.jobnotificationschecked = response.data.jobNotifiacations;
        }
      }).catch((e) => {
        console.log(e)
        this.disableOptions = false;
      })
    },
    // this will invoke while scrolling dow to get more records
    handleScroll() {
      let scrollPosition = window.scrollY
      var that = this;
      if(this.instanceNotificationList && this.instanceNotificationList.length > 8) {
        this.instancegatData = true
      }else{
        this.instancegatData = false;
      }
      if(this.instancegatData) {
        if ((window.innerHeight + window.scrollY+1) >= document.body.offsetHeight) {
          that.instanceLoader = true;
          that.startNumber = that.startNumber + 10;
          if(this.activeClass == 'all_notifications') {
          that.loadMoreNotifications()
          }else if(this.activeClass == 'videos') {
            that.loadMoreVideoNotifications()
          }else if(this.activeClass == 'jobs'){
            that.fetchJobNotifications()
          }
        }
      }
    },
    // fetching list of notiifcations
    // get notifications and seperate the notifications based on date
    fetchNotificationsList : function() {
      this.instanceNotificationList = [];
      var equalCount = 0;
      var lessCount = 0;
      ///params change to offset limit
      httpuserprofile.get('userprofile/getNotificationList',{
        params: { profileId : this.profileId,
        offset : this.startNumber,
        limit : this.limit }
      }).then((response) => {
        this.pageloader = false;
        this.individualpageloader = false;
        this.instancegatData = true;
        // console.log("notifications list mainpage : ", response)
        this.instanceNotificationList = response.data.list;
        this.totalNotificationCount = response.data.totalRecords;
        // console.log("instance list : ", this.instanceNotificationList)
        this.instanceLoader = false;
        for(var i =0; i < this.instanceNotificationList.length; i++) {
          //set popover Name to append name dynamically
          this.instanceNotificationList[i].popoverName = 'popover' + this.instanceNotificationList[i].id;
          //date display on top of notification list
          //to show date as  a header
          if(this.instanceNotificationList[i].lastUpdatedD) {
            // console.log("enter into lastupdatedD : ", i)
            // var date = new Date();
            // var itemDate = new Date(this.instanceNotificationList[i].lastUpdatedD)
            // let getDatedate = date.getDate()
            // let getDatemonth = date.getMonth()
            // let itemDatedate = itemDate.getDate()
            // let itemDatemonth = itemDate.getMonth()
            var date = moment().format('DD/MM/YYYY')
            var itemDate = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
            let getDatedate = String(date).substring(0, 2)
            let getDatemonth = String(date).substring(3, 5)
            let itemDatedate = String(itemDate).substring(0, 2)
            let itemDatemonth = String(itemDate).substring(3, 5)
            if((itemDatemonth == getDatemonth) && (itemDatedate == getDatedate) ){
              //check with last array item date 
              if(this.totalNotificationList.length > 0) {
                // let dateCheck = new Date(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD)
                // let prevDate = dateCheck.getDate()
                // let prevMonth = dateCheck.getMonth()
                let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD).format('DD/MM/YYYY')
                let prevDate = String(dateCheck).substring(0, 2)
                let prevMonth = String(dateCheck).substring(3, 5)
                if((getDatedate == prevDate) && (getDatemonth == prevMonth)){
                  //if the date & month are qual ... take the count of previous item and increment and add to the new item
                  equalCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                  equalCount++
                  // console.log("equal count : ", equalCount, i)
                }
              }else{
                // console.log("check date : ", i)
              }
              this.instanceNotificationList[i].dateStr = 'Today'
              this.instanceNotificationList[i].checkcount = equalCount;
              equalCount++;
            }else if((itemDatemonth == getDatemonth) && (itemDatedate <  getDatedate)){
              // this.instanceNotificationList[i].dateStr = itemDate.toISOString().split('T')[0]
              //check with last array item date
              // console.log("check equal month  and less date : ", i)
              if (i < 1) {
                if(this.totalNotificationList.length > 0) {
                  // console.log("phase1 in check equal month  and less date")
                  // let dateCheck = new Date(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD)
                  // let prevDate = dateCheck.getDate()
                  // let prevMonth = dateCheck.getMonth()
                  let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD).format('DD/MM/YYYY')
                  let prevDate = String(dateCheck).substring(0, 2)
                  let prevMonth = String(dateCheck).substring(3, 5)
                  if((itemDatedate == prevDate) && (itemDatemonth == prevMonth)){
                    // console.log("inner phase1")
                    //if the date & month are qual ... take the count of previous item and increment and add to the new item
                    lessCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                    lessCount++
                    // console.log("count less increase : ", lessCount)
                  }else{
                    //need to implement the case statement
                    lessCount = 0
                    this.instanceNotificationList[i].checkcount = lessCount;
                    // let dateAdd = new Date(this.instanceNotificationList[i].lastUpdatedD)
                    let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
                    let date = String(dateAdd).substring(0, 2);
                    let year = String(dateAdd).substring(6)
                    let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
                    this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                    lessCount++
                    // console.log("count zero : ", lessCount)
                  }
                }else{
                  lessCount = 0
                  this.instanceNotificationList[i].checkcount = lessCount;
                  // let dateAdd = new Date(this.instanceNotificationList[i].lastUpdatedD)
                  let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                  lessCount++
                  // console.log("count zero : ", lessCount)
                }
              }else{
                // console.log("phase2 in check equal month  and less date")
                // let instanceprevDate = new Date(this.instanceNotificationList[i-1].lastUpdatedD)
                let instanceprevDate = moment(this.instanceNotificationList[i-1].lastUpdatedD).format('DD/MM/YYYY')
                let prevDate = String(instanceprevDate).substring(0, 2)
                if( prevDate == itemDatedate) {
                  // console.log("inner phase2")
                  equalCount = this.instanceNotificationList[i-1].checkcount;
                  equalCount ++
                  this.instanceNotificationList[i].checkcount = equalCount
                  // let dateAdd = new Date(this.instanceNotificationList[i].lastUpdatedD)
                  let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                  // console.log("count equal increase : ", lessCount)
                }else{
                  lessCount = 0;
                  this.instanceNotificationList[i].checkcount = lessCount
                  // let dateAdd = new Date(this.instanceNotificationList[i].lastUpdatedD)
                  let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                  // console.log("count zero : ", lessCount)
                }
              }
              // if(i > 0) {
              //   console.log("phase2 in check equal month  and less date")
              //   let instanceprevDate = new Date(this.instanceNotificationList[i-1].lastUpdatedD)
              //   if( instanceprevDate.getDate() == itemDatedate) {
              //     console.log("inner phase2")
              //     equalCount = this.instanceNotificationList[i-1].checkcount;
              //     equalCount ++
              //     console.log("count equal increase : ", lessCount)
              //   }else{
              //     lessCount = 0;
              //     console.log("count zero : ", lessCount)
              //   }
              // }
              // if(this.instanceNotificationList[i].dateStr == '' || this.instanceNotificationList[i].dateStr == null || this.instanceNotificationList[i].dateStr == undefined){
              //   console.log("phase3 in check equal month  and less date")
              //   console.log("inner phase")
              //   let dateAdd = new Date(this.instanceNotificationList[i].lastUpdatedD)
              //   let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
              //   this.instanceNotificationList[i].dateStr = dateAdd.getDate() + '/'  + month + '/'  + dateAdd .getFullYear()
              //   this.instanceNotificationList[i].checkcount = lessCount;
              //   lessCount++
              // }
            }else{
              // console.log("final else : ", i)
              if(this.totalNotificationList.length > 0) {
                // let dateCheck = new Date(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD)
                // let prevDate = dateCheck.getDate()
                // let prevMonth = dateCheck.getMonth()
                let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD).format('DD/MM/YYYY')
                let prevDate = String(dateCheck).substring(0, 2)
                let prevMonth = String(dateCheck).substring(3, 5)
                if((getDatedate == prevDate) && (getDatemonth == prevMonth)){
                  lessCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                  lessCount++
                }else{
                  lessCount = 0
                }
              }
              if(i > 0) {
                // let instanceprevDate = new Date(this.instanceNotificationList[i-1].lastUpdatedD)
                let instanceprevDate = moment(this.instanceNotificationList[i-1].lastUpdatedD).format('DD/MM/YYYY')
                let instanceprevDateDate = String(instanceprevDate).substring(0, 2)
                if( instanceprevDateDate == itemDatedate) {
                  equalCount = this.instanceNotificationList[i-1].checkcount;
                  equalCount ++
                }else{
                  lessCount = 0;
                }
              }
              // let dateAdd = new Date(this.instanceNotificationList[i].lastUpdatedD)
              // let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
              // this.instanceNotificationList[i].dateStr = dateAdd.getDate() + '/'  + month + '/'  + dateAdd .getFullYear()
              let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
              let date = String(dateAdd).substring(0, 2);
              let year = String(dateAdd).substring(6)
              let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
              this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
              this.instanceNotificationList[i].checkcount = lessCount;
              lessCount++
            }
          }
        
        }
        //push instance array into final array to display in notifications page
        for(var j =0; j < this.instanceNotificationList.length; j++){
          if(this.instanceNotificationList[j].lastUpdatedD) {
            this.totalNotificationList.push(this.instanceNotificationList[j])
          }   
        }
        // console.log(this.totalNotificationList)
      }).catch((error) => {
        // console.log(error)
        this.pageloader = false;
        this.individualpageloader = false;
        this.instanceLoader = false;
        this.instancegatData = true;
      })
    },
    fetchVideoNotifications() {
      this.instanceNotificationList = [];
      var equalCount = 0;
      var lessCount = 0;
      ///params change to offset limit
      httpuserprofile.get('userprofile/getPostedVideoNotificationList',{
        params: { profileId : this.profileId,
        offset : this.startNumber,
        limit : this.limit }
      }).then((response) => {
        this.pageloader = false;
        this.individualpageloader = false;
        this.instancegatData = true;
        // console.log("notifications list mainpage : ", response)
        this.instanceNotificationList = response.data.list;
        this.totalNotificationCount = response.data.totalRecords;
        // console.log("instance list : ", this.instanceNotificationList)
        this.instanceLoader = false;
        for(var i =0; i < this.instanceNotificationList.length; i++) {
          //set popover Name to append name dynamically
          this.instanceNotificationList[i].popoverName = 'popover' + this.instanceNotificationList[i].id;
          //date display on top of notification list
          //to show date as  a header
          if(this.instanceNotificationList[i].lastUpdatedD) {
            var date = moment().format('DD/MM/YYYY')
            var itemDate = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
            let getDatedate = String(date).substring(0, 2)
            let getDatemonth = String(date).substring(3, 5)
            let itemDatedate = String(itemDate).substring(0, 2)
            let itemDatemonth = String(itemDate).substring(3, 5)
            if((itemDatemonth == getDatemonth) && (itemDatedate == getDatedate) ){
              //check with last array item date 
              if(this.totalNotificationList.length > 0) {
                let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD).format('DD/MM/YYYY')
                let prevDate = String(dateCheck).substring(0, 2)
                let prevMonth = String(dateCheck).substring(3, 5)
                if((getDatedate == prevDate) && (getDatemonth == prevMonth)){
                  //if the date & month are qual ... take the count of previous item and increment and add to the new item
                  equalCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                  equalCount++
                }
              }else{
                // console.log("check date : ", i)
              }
              this.instanceNotificationList[i].dateStr = 'Today'
              this.instanceNotificationList[i].checkcount = equalCount;
              equalCount++;
            }else if((itemDatemonth == getDatemonth) && (itemDatedate <  getDatedate)){
              if (i < 1) {
                if(this.totalNotificationList.length > 0) {
                  let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD).format('DD/MM/YYYY')
                  let prevDate = String(dateCheck).substring(0, 2)
                  let prevMonth = String(dateCheck).substring(3, 5)
                  if((itemDatedate == prevDate) && (itemDatemonth == prevMonth)){
                    //if the date & month are qual ... take the count of previous item and increment and add to the new item
                    lessCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                    lessCount++
                  }else{
                    //need to implement the case statement
                    lessCount = 0
                    this.instanceNotificationList[i].checkcount = lessCount;
                    let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
                    let date = String(dateAdd).substring(0, 2);
                    let year = String(dateAdd).substring(6)
                    let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
                    this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                    lessCount++
                  }
                }else{
                  lessCount = 0
                  this.instanceNotificationList[i].checkcount = lessCount;
                  let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                  lessCount++
                }
              }else{
                let instanceprevDate = moment(this.instanceNotificationList[i-1].lastUpdatedD).format('DD/MM/YYYY')
                let prevDate = String(instanceprevDate).substring(0, 2)
                if( prevDate == itemDatedate) {
                  equalCount = this.instanceNotificationList[i-1].checkcount;
                  equalCount ++
                  this.instanceNotificationList[i].checkcount = equalCount
                  let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                }else{
                  lessCount = 0;
                  this.instanceNotificationList[i].checkcount = lessCount
                  let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                }
              }
            }else{
              if(this.totalNotificationList.length > 0) {
                let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].lastUpdatedD).format('DD/MM/YYYY')
                let prevDate = String(dateCheck).substring(0, 2)
                let prevMonth = String(dateCheck).substring(3, 5)
                if((getDatedate == prevDate) && (getDatemonth == prevMonth)){
                  lessCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                  lessCount++
                }else{
                  lessCount = 0
                }
              }
              if(i > 0) {
                let instanceprevDate = moment(this.instanceNotificationList[i-1].lastUpdatedD).format('DD/MM/YYYY')
                let instanceprevDateDate = String(instanceprevDate).substring(0, 2)
                if( instanceprevDateDate == itemDatedate) {
                  equalCount = this.instanceNotificationList[i-1].checkcount;
                  equalCount ++
                }else{
                  lessCount = 0;
                }
              }
              let dateAdd = moment(this.instanceNotificationList[i].lastUpdatedD).format('DD/MM/YYYY')
              let date = String(dateAdd).substring(0, 2);
              let year = String(dateAdd).substring(6)
              let month = String(this.instanceNotificationList[i].lastUpdatedD).substring(5, 7);
              this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
              this.instanceNotificationList[i].checkcount = lessCount;
              lessCount++
            }
          }
        
        }
        //push instance array into final array to display in notifications page
        for(var j =0; j < this.instanceNotificationList.length; j++){
          if(this.instanceNotificationList[j].lastUpdatedD) {
            this.totalNotificationList.push(this.instanceNotificationList[j])
          }   
        }
      }).catch((error) => {
        this.pageloader = false;
        this.individualpageloader = false;
        this.instanceLoader = false;
        this.instancegatData = true;
      })
    },
    fetchJobNotifications() {
      this.instanceNotificationList = [];
      var equalCount = 0;
      var lessCount = 0;
      ///params change to offset limit
      httpjob.get('postjob/getJobNotificationList',{
        params: { profileId : this.profileId,
        offset : this.startNumber,
        limit : this.limit }
      }).then((response) => {
        console.log("job notifications : ", response)
        this.pageloader = false;
        this.individualpageloader = false;
        this.instancegatData = true;
        // console.log("notifications list mainpage : ", response)
        this.instanceNotificationList = response.data;
        // this.totalNotificationCount = response.data.totalRecords;
        // console.log("instance list : ", this.instanceNotificationList)
        this.instanceLoader = false;
        for(var i =0; i < this.instanceNotificationList.length; i++) {
          //set popover Name to append name dynamically
          this.instanceNotificationList[i].popoverName = 'popover' + this.instanceNotificationList[i].id;
          //date display on top of notification list
          //to show date as  a header
          if(this.instanceNotificationList[i].creationD) {
            var date = moment().format('DD/MM/YYYY')
            var itemDate = moment(this.instanceNotificationList[i].creationD).format('DD/MM/YYYY')
            let getDatedate = String(date).substring(0, 2)
            let getDatemonth = String(date).substring(3, 5)
            let itemDatedate = String(itemDate).substring(0, 2)
            let itemDatemonth = String(itemDate).substring(3, 5)
            if((itemDatemonth == getDatemonth) && (itemDatedate == getDatedate) ){
              //check with last array item date 
              if(this.totalNotificationList.length > 0) {
                let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].creationD).format('DD/MM/YYYY')
                let prevDate = String(dateCheck).substring(0, 2)
                let prevMonth = String(dateCheck).substring(3, 5)
                if((getDatedate == prevDate) && (getDatemonth == prevMonth)){
                  //if the date & month are qual ... take the count of previous item and increment and add to the new item
                  equalCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                  equalCount++
                }
              }else{
                // console.log("check date : ", i)
              }
              this.instanceNotificationList[i].dateStr = 'Today'
              this.instanceNotificationList[i].checkcount = equalCount;
              equalCount++;
            }else if((itemDatemonth == getDatemonth) && (itemDatedate <  getDatedate)){
              if (i < 1) {
                if(this.totalNotificationList.length > 0) {
                  let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].creationD).format('DD/MM/YYYY')
                  let prevDate = String(dateCheck).substring(0, 2)
                  let prevMonth = String(dateCheck).substring(3, 5)
                  if((itemDatedate == prevDate) && (itemDatemonth == prevMonth)){
                    //if the date & month are qual ... take the count of previous item and increment and add to the new item
                    lessCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                    lessCount++
                  }else{
                    //need to implement the case statement
                    lessCount = 0
                    this.instanceNotificationList[i].checkcount = lessCount;
                    let dateAdd = moment(this.instanceNotificationList[i].creationD).format('DD/MM/YYYY')
                    let date = String(dateAdd).substring(0, 2);
                    let year = String(dateAdd).substring(6)
                    let month = String(this.instanceNotificationList[i].creationD).substring(5, 7);
                    this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                    lessCount++
                  }
                }else{
                  lessCount = 0
                  this.instanceNotificationList[i].checkcount = lessCount;
                  let dateAdd = moment(this.instanceNotificationList[i].creationD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].creationD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                  lessCount++
                }
              }else{
                let instanceprevDate = moment(this.instanceNotificationList[i-1].creationD).format('DD/MM/YYYY')
                let prevDate = String(instanceprevDate).substring(0, 2)
                if( prevDate == itemDatedate) {
                  equalCount = this.instanceNotificationList[i-1].checkcount;
                  equalCount ++
                  this.instanceNotificationList[i].checkcount = equalCount
                  let dateAdd = moment(this.instanceNotificationList[i].creationD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].creationD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                }else{
                  lessCount = 0;
                  this.instanceNotificationList[i].checkcount = lessCount
                  let dateAdd = moment(this.instanceNotificationList[i].creationD).format('DD/MM/YYYY')
                  let date = String(dateAdd).substring(0, 2);
                  let year = String(dateAdd).substring(6)
                  let month = String(this.instanceNotificationList[i].creationD).substring(5, 7);
                  this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
                }
              }
            }else{
              if(this.totalNotificationList.length > 0) {
                let dateCheck = moment(this.totalNotificationList[this.totalNotificationList.length-1].creationD).format('DD/MM/YYYY')
                let prevDate = String(dateCheck).substring(0, 2)
                let prevMonth = String(dateCheck).substring(3, 5)
                if((getDatedate == prevDate) && (getDatemonth == prevMonth)){
                  lessCount = this.totalNotificationList[this.totalNotificationList.length-1].checkcount
                  lessCount++
                }else{
                  lessCount = 0
                }
              }
              if(i > 0) {
                let instanceprevDate = moment(this.instanceNotificationList[i-1].creationD).format('DD/MM/YYYY')
                let instanceprevDateDate = String(instanceprevDate).substring(0, 2)
                if( instanceprevDateDate == itemDatedate) {
                  equalCount = this.instanceNotificationList[i-1].checkcount;
                  equalCount ++
                }else{
                  lessCount = 0;
                }
              }
              let dateAdd = moment(this.instanceNotificationList[i].creationD).format('DD/MM/YYYY')
              let date = String(dateAdd).substring(0, 2);
              let year = String(dateAdd).substring(6)
              let month = String(this.instanceNotificationList[i].creationD).substring(5, 7);
              this.instanceNotificationList[i].dateStr = date + '/'  + month + '/'  + year
              this.instanceNotificationList[i].checkcount = lessCount;
              lessCount++
            }
          }
        
        }
        //push instance array into final array to display in notifications page
        for(var j =0; j < this.instanceNotificationList.length; j++){
          if(this.instanceNotificationList[j].creationD) {
            this.totalNotificationList.push(this.instanceNotificationList[j])
          }   
        }
      }).catch((error) => {
        this.pageloader = false;
        this.individualpageloader = false;
        this.instanceLoader = false;
        this.instancegatData = true;
      })
    }
  },
};
</script>
<style scoped>
.line {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.1;
}
ul li::marker {
    color: #1f1f1f;
    text-decoration: underline;
    opacity: 0.8;
    font-size: 0px;
    list-style: none !important;
    margin-left: -10px !important;
  }
  .loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 20px 20px;
}
  .list-Font-color{
    opacity: 0.8;
    color: #1F1F1F;
    font-family: "Proxima Nova";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
  }
  .list-text-color{
    color: #0078FF;
    font-family: "Proxima Nova";
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
  }
  .form-control {
    /* background-color: rgb(236, 236, 238) !important; */
    background-color: rgba(161, 166, 179, 0.1) !important;
    height: 42px;
    border: none;
    padding-bottom: 10px;
    margin-bottom: 4px !important;
    /* border: 0px solid #ced4da !important; */
    /* border-radius: 10px 10px 10px 10px !important; */
  
  }
  #profImage{
  width: 30px;
  height: 30px;
  line-height: 30px;
}
  .action {
    cursor: pointer;
  }
  .action:hover {
    background-color:rgba(221, 223, 229,0.4);
    border-radius: 5px;
  }
  .notyname {
      font-weight: bold;
      font-size: 14px;
      color: rgba(31,31,31,1);
  }
  .input-group-prepend{
    margin-left: -15px;
  }
  .input-group-text {
    padding: 0px 0px 0px 0px !important;
  }
  .border-tab{
    border-left-style: solid;
    border-left-width:4px;
    border-left-color: #0078FF;
  }
  .pageloader {
    width: 7%;
    margin-top: 15%;
    margin-left: 46%;
  }
  .instanceloader{
    width: 7%;
    margin-top: 2%;
    margin-left: 48%;
  }
  .border-tab-bottom{
    border-bottom-style: solid;
    border-bottom-color: #0078FF;
  }
  .nav-tabs {
    border-bottom: none;
  }
  .card {
    border: 1px solid #dddfe5;
    border-radius: 10px;
    background-color: #ffffff;
  }
  .navigation{
      border-radius: 10px;
  }
  .checkbag {
      background-color: rgba(161, 166, 179, 0.1);
  }
  .notyicon {
    display: none;
  }
  .notyprofile{
    height: 30px;
    width: 30px;
  }
  .userimg {
      width: 30px;
  }
  .checkbagnotread:hover .notyicon {
    display: block;
    cursor: pointer;
  }
  .checkbag:hover .notyicon{
    display: block;
    cursor: pointer;
  }
  .hover{
    cursor: pointer;
  }
  .checkbagnotread {
      background-color: white;
  }
  .checkbagsearch{
      border: 1px solid #D9DCE1;
      background-color: #F0F2F5;
  }
  .pending {
    padding: 0px 0px 0px 0px;
  }
  
  .active {
    border-bottom: 1px red !important;
  }
  .border-bottom{
    margin-left: 20px;
    margin-right: 20px
  }
  .header {
    position: fixed;
    width: 100%;
    z-index: 10;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);
  }
  .label-bottom {
    margin-bottom: 0.25rem !important;
    margin-top: 0.25rem !important;
  }
  .imgborder {
    padding: 11px 15px 10px 11px;
    background-color: rgba(161, 166, 179, 0.1);
    border-radius: 10px 0px 0px 10px;
  }
  input:focus,
  textarea:focus {
    outline: none; /** For Safari, etc **/
    border: transparent;
  }
  .coloredfont12 {
    color: #fc597f;
    font-family: "Proxima Nova";
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;
  }
  .slide-background{
    background-color: rgba(243, 244, 247, 0.5);
  }
  .carousel-control-next,
  .carousel-control-prev {
      filter: invert(50%);
  }
  .carousel-inner{
    width: 270px;
    padding: 1em 2.5em;
  }
  .carousel-item{
    padding: 20%;
  }
  .carousel-img{
    width: 30px;
    margin-left: 42%;
  }
  .pdtext {
    font-size: 13px;
    padding: 0 1em 1em 0;
    text-align: center;
  }
  .jobSec{
    margin-top: 15% !important;
  }
  .pendingSec, .jobSec{
    /* background-color: #e8e9eb; */
    background-color: rgba(161, 166, 179, 0.085);
    border: none;
  }
  .hr-theme-slash-2 {
    display: flex;
  }
  .hr-line {
    width: 100%;
    position: relative;
    margin: 15px;
    border-bottom: 1px solid #c5c7c9;
  }
  .hr-icon {
    position: relative;
    color: #757778;
    font-size: 10px;
    border: 2px solid #c5c7c9;  
  }
  .loadmore {
    border : 1px solid  rgba(161, 166, 179, 0.1);
    border-radius: 5px;
    margin-bottom: 20px;
  }
  
  /* Notification Actions */
  .dropdown-position-bottom.notificationActions {
      color: rgba(31,31,31,1)  !important;
      font-size: 12px !important;
      top: 50px !important;
      font-weight: 500;
      width: 189px !important;
      left: -55px !important;
      /* padding: 20px 0px 0px 20px !important; */
  }
  .vue-popover.dropdown-position-bottom.notificationActions:before {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    top: -8px;
    left: 120px !important;
    filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
  }
  .dropdown-position-bottom.notificationActionsAll {
    top: 25px !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    left: 17% !important;
    width: 219px !important;
    font-weight: 500;
  }
  .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
    left: 76% !important;
  }
  .footer {
    z-index: 5;
  }
  @media screen and (max-width: 1020px) and (min-width: 767px) {
    .main-card {
      padding-left: 5% !important;
      padding-right: 5% !important;
    }
    .mobviewItems{
      overflow: auto;
    }
  }
  @media only screen and (max-width: 600px) {
    .pageloader {
      width: 20%;
      margin-top: 25%;
      margin-left: 42%;
    }
    .instanceloader{
      width: 14%;
      margin-left: 42%;
    }
    .footer {
      position: fixed;
      bottom: 0;
    }
    .pendingSec, .jobSec{
      display: none;
    }
    .topmenubar {
      margin-left: 1.5em;
    }
    .notyicon {
      display: block;
    }
    /* Notification Actions */
    .dropdown-position-bottom.notificationActions {
      top: 70px !important;
      left: -110px !important;
    }
    .dropdown-position-bottom.notificationActionsAll {
      left: 35% !important;
    }
    .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
      left: 85% !important;
    }
  }
  @media screen and (max-width: 580px) and (min-width: 500px){
    .dropdown-position-bottom.notificationActionsAll {
      left: 57% !important;
    }
    .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
      left: 85% !important;
    }
  }
  @media screen and (max-width: 350px) and (min-width: 300px){
    .dropdown-position-bottom.notificationActionsAll {
      left: 27% !important;
    }
    .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
      left: 85% !important;
    }
  }
  @media screen and (max-width: 1030px) and (min-width: 770px){
    .dropdown-position-bottom.notificationActionsAll {
      left: 10% !important;
      margin-top: 4% !important;
    }
    .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
      left: 50% !important;
    }
  }
  @media screen and (max-width: 400px) and (min-width: 350px){
    .dropdown-position-bottom.notificationActionsAll {
      left: 38% !important;
    }
    .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
      left: 85% !important;
    }
  }
  @media screen and (max-width: 450px) and (min-width: 400px){
    .dropdown-position-bottom.notificationActionsAll {
      left: 45% !important;
    }
    .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
      left: 85% !important;
    }
  }
  @media screen and (max-width: 820px) and (min-width: 770px) {
    .dropdown-position-bottom.notificationActionsAll {
      top: 0px !important;
      left: 70% !important;
    }
    .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
      left: 74% !important;
    }
  }
  @media screen and (max-width: 769px) and (min-width: 600px) {
    .footer {
      position: fixed;
      bottom: 0;
    }
    .notyicon {
      display: block;
    }
    .dropdown-position-bottom.notificationActionsAll {
      left: 67% !important;
    }
    .vue-popover.dropdown-position-bottom.notificationActionsAll:before {
      left: 76% !important;
    }
  }
  
</style>